module.exports = __webpack_public_path__ + "img/icons-3.49243773.png";